module.exports = __webpack_public_path__ + "static/media/grade9.44c45e0f.jpg";